export default {"src":"/_next/static/media/USFlag.83aeec85.svg","height":24,"width":32};